import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IsortTypeOptionItem, TSortingContainerProps } from './SortingContainer.type';
import { CANCEL_TEXT, OK_TEXT, TOOLTIP_MESSAGE } from '../../../Constants/Constants';
import CustomModal from '../CustomModal/CustomModal';
import './SortingContainer.scss';

const SortingContainer = (props: TSortingContainerProps) => {
  const {
    showLabel = false,
    sortDirection,
    selectedValue,
    sortTypeOptions,
    handleSortType,
    handleSortDirectionChange = () => toast(TOOLTIP_MESSAGE),
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');

  useEffect(() => {
    if (isModalOpen) {
      setSelectedItem(selectedValue);
    } else {
      setSelectedItem('');
    }
  }, [isModalOpen, selectedValue]);

  const showTitle = () => {
    return sortTypeOptions?.find((item: IsortTypeOptionItem) => item.slug === selectedValue)?.title;
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalOk = () => {
    handleSortType(selectedItem);
    setIsModalOpen(false);
  };

  const handleSortTypeClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="SortingContainer">
      <CustomModal
        isModalOpen={isModalOpen}
        title="Sort by"
        additionalCssClass="Sorting_Dropdown_Container Sorting_Modal"
        backdropDismiss={false}
        buttons={[
          {
            title: CANCEL_TEXT,
            type: 'secondary-cta-btn',
            onClick: handleModalClose,
          },
          {
            title: OK_TEXT,
            type: 'primary-cta-btn',
            onClick: handleModalOk,
          },
        ]}
      >
        <div className="Dropdown_Items_Container">
          {sortTypeOptions
            ?.filter((item: IsortTypeOptionItem) => !item.hide)
            .map((item: IsortTypeOptionItem) => (
              <div
                key={item?.slug}
                className={`Dropdown_Item ${item?.slug}`}
                data-testid={`Dropdown_Item_${item?.slug}`}
                onClick={() => setSelectedItem(item?.slug)}
              >
                <span>{item?.title}</span>
                {item?.slug === selectedItem && (
                  <img src="/oo/assets/icon/tick-icon.svg" alt="selected" />
                )}
              </div>
            ))}
        </div>
      </CustomModal>
      {showLabel && <div className="SortingContainer_label">Sort By :</div>}
      <div
        className="SortingContainer_sort_type"
        data-testid="SortingContainer_sort_type"
        onClick={handleSortTypeClick}
      >
        <span>{showTitle()}</span>
        <img src="/oo/assets/icon/grid-down-arrow-thin.svg" alt="down-arrow" />
      </div>
      {sortDirection && (
        <div
          className="SortingContainer_sort_direction"
          data-testid="SortingContainer_sort_direction"
          onClick={handleSortDirectionChange}
        >
          <img
            src={`/oo/assets/icon/sort_direction_${sortDirection}.svg`}
            alt={sortDirection}
            data-testid="sortDirection_icon"
          />
        </div>
      )}
    </div>
  );
};

export default SortingContainer;
